import { Form } from "devextreme-react";
import {
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import styled from "styled-components";
import { projectStatus } from "../SalesManagement/Payment/data";
import { useDispatch } from "react-redux";
import {
  updateColor,
  updateName,
  updatePrioCodeId,
  updateProjStatusCodeId,
  updateSprCode,
  updateSprEnName,
  updateSprName,
} from "./Redux/contract";

const FormWrapper = styled.div`
  margin: 0 20px;
  .dx-field-item-required-mark {
    color: red;
  }
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
  .dx-cell-modified:not(.dx-datagrid-invalid) {
    background-color: transparent !important;
  }
  .dx-data-row {
    white-space: pre-wrap;
  }
  /* .dx-dropdowneditor-input-wrapper .dx-texteditor-input {
    word-wrap: break-word;
    white-space: normal;
  } */
  .dx-button {
    margin: 0;
  }
  .dx-colorbox
    .dx-colorbox-input-container
    .dx-dropdowneditor-input-wrapper
    .dx-colorbox-input {
    font-size: 1em;
  }
`;

export default function ContractForm(props) {
  const { contractFormRef, priorityDataSource, contract } = props;

  const dispatch = useDispatch();

  const onSprCodeValueChanged = (e) => {
    dispatch(
      updateSprCode({
        sprCode: e.value,
      })
    );
  };

  const onSprNameValueChanged = (e) => {
    dispatch(
      updateSprName({
        sprName: e.value,
      })
    );
  };

  const onSprEnNameValueChanged = (e) => {
    dispatch(
      updateSprEnName({
        sprEnName: e.value,
      })
    );
  };

  const onProjStatusCodeIdValueChanged = (e) => {
    dispatch(
      updateProjStatusCodeId({
        projStatusCodeId: e.value,
      })
    );
  };

  const onPrioCodeIdValueChanged = (e) => {
    dispatch(
      updatePrioCodeId({
        prioCodeId: e.value,
      })
    );
  };

  const onNameValueChanged = (e) => {
    dispatch(
      updateName({
        name: e.value,
      })
    );
  };

  const onColorValueChanged = (e) => {
    dispatch(
      updateColor({
        color: e.value,
      })
    );
  };

  return (
    <FormWrapper>
      <Form
        id="form-Contract"
        ref={contractFormRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="contractData"
      >
        <SimpleItem
          dataField={"sprCode"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: contract.spr.sprCode,
            onValueChanged: onSprCodeValueChanged,
          }}
        >
          <Label text={"Sponsor Code"} />
          <RequiredRule message={"Sponsor code is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"sprName"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: contract.spr.sprName,
            onValueChanged: onSprNameValueChanged,
          }}
        >
          <Label text={"Sponsor Name"} />
          <RequiredRule message={"Sponsor name is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"sprEnName"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: contract.spr.sprEnName,
            onValueChanged: onSprEnNameValueChanged,
          }}
        >
          <Label text={"Sponsor English Name"} />
          <RequiredRule message={"Sponsor English name is required."} />
        </SimpleItem>
        <EmptyItem />
        <SimpleItem
          dataField={"projStatusCodeId"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: projectStatus,
            valueExpr: "codeId",
            displayExpr: "name",
            value: contract.proj.projStatusCodeId,
            onValueChanged: onProjStatusCodeIdValueChanged,
          }}
        >
          <Label text={"Status"} />
        </SimpleItem>
        <SimpleItem
          dataField={"prioCodeId"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: priorityDataSource,
            valueExpr: "codeId",
            displayExpr: "name",
            value: contract.proj.prioCodeId,
            onValueChanged: onPrioCodeIdValueChanged,
          }}
        >
          <Label text={"Priority"} />
        </SimpleItem>
        <SimpleItem
          dataField={"color"}
          editorType={"dxColorBox"}
          editorOptions={{
            value: contract.proj.color,
            onValueChanged: onColorValueChanged,
          }}
        >
          <Label text={"Color"} />
        </SimpleItem>
        <EmptyItem />
        <SimpleItem
          dataField={"contrNo"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: contract.contrNo,
            readOnly: true,
          }}
        >
          <Label text={"Contract No."} />
        </SimpleItem>
        <SimpleItem
          dataField={"name"}
          editorType={"dxTextBox"}
          colSpan={3}
          editorOptions={{
            value: contract.proj.name,
            onValueChanged: onNameValueChanged,
          }}
        >
          <Label text={"Project Name"} />
        </SimpleItem>
      </Form>
    </FormWrapper>
  );
}
